export default {
      id: "LOGO-FOOTER-VERTICAL-usage",
      viewBox: "0 0 138 187",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#LOGO-FOOTER-VERTICAL-usage",
      toString: function () {
        return this.url;
      }
    }